import moment from 'moment-timezone'
import { IReportConfig } from '../interfaces/report-config'
import { titleCase } from '../../../_utils/utils'

const DISPLAY_DATE_FORMAT = 'll'

/**
 * Renders the window a saved report covers, for the saved reports list.
 *
 * A report carries either a relative preset key or an explicit range, never both, and may carry
 * neither — an unbounded report is a real, saveable configuration (a uniques report grouped by
 * month always is), and reads as "All Time" here and in the report builder's date picker.
 *
 * Either endpoint may be absent on its own, which the insights API accepts as an open-ended
 * window, so each side is only rendered when it is actually set. A missing endpoint must never
 * reach `moment()`, which reads an absent date as the current moment and would report an
 * unbounded report as covering today alone.
 */
export function formatSavedReportDateRange(
    reportConfig: Pick<IReportConfig, 'dateRangePresetKey' | 'dateRange'>,
): string {
    if (reportConfig.dateRangePresetKey) {
        return titleCase(reportConfig.dateRangePresetKey)
    }

    const since = reportConfig.dateRange?.since
    const through = reportConfig.dateRange?.through

    if (since && through) {
        return `${moment(since).format(DISPLAY_DATE_FORMAT)} - ${moment(through).format(DISPLAY_DATE_FORMAT)}`
    }

    if (since) {
        return `Since ${moment(since).format(DISPLAY_DATE_FORMAT)}`
    }

    if (through) {
        return `Through ${moment(through).format(DISPLAY_DATE_FORMAT)}`
    }

    return 'All Time'
}
